import script from "./sidebar-teams-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar-teams-button.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__